module.exports = __webpack_public_path__ + "img/11passenger_stopped.18b6c656.svg";